import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(2),
  },
  item: {
    marginTop: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
}))

export default useStyles
